import React from 'react'
import { FormikProps } from 'formik'
import { Toast, Spinner } from 'lib/ui'
import { useAuthNet } from 'lib/core/hooks'
import {
  useCheckout,
  usePaymentMethod,
  CreditCardForm,
  CreditCardData,
  CreditCardFormValues
} from 'lib/modules/checkout'
import { Container } from './styled'

let values: CreditCardData
let formik: FormikProps<CreditCardFormValues>

export const AuthNet = () => {
  const { paymentMethod } = useCheckout()
  const { code } = paymentMethod
  const { authorizeCardAndPlaceOrder, isLoading } = useAuthNet()

  usePaymentMethod(({ placeOrder }) => {
    formik.handleSubmit()
    formik.validateForm().then((errors) => {
      const hasErrors = !!Object.keys(errors).length
      if (!hasErrors) {
        authorizeCardAndPlaceOrder({
          values: values
        }).then((authorizations) => {
          if (!authorizations) {
            Toast.toastFailure({
              messageId: 'checkout.braintree.invalidCreditCard'
            })
          } else {
            placeOrder({
              additionalData:
                authorizations[0]
            })
          }
        }).catch((error) => {
          Toast.toastFailure({
            messageId: 'checkout.braintree.invalidCreditCard',
            message: error.message
          })
        })
      }
    })
  })

  const handleChange = (formValues: CreditCardData, formikObject: FormikProps<CreditCardFormValues>) => {
    values = formValues
    formik = formikObject
  }

  return (
    <Container>
      {isLoading ? (
        <Spinner />
      ) : (
        <CreditCardForm
          key={code}
          onChange={handleChange}
        />)}
    </Container>
  )
}
